var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContractColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "29.6666667px",
    viewBox: "0 0 33 29.6666667",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Administrateur---Param\\xE8tres",
    transform: "translate(-79.500000, -534.166667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(40.000000, 501.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(36.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 5,
    y: 6.66666667,
    width: 30,
    height: 26.6666667,
    rx: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    fill: "#AFBC9D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 15,
    cy: 16.6666667,
    r: 3.33333333
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 13.3333333,
    x2: 28.3333333,
    y2: 13.3333333,
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 20,
    x2: 28.3333333,
    y2: 20,
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.6666667,
    y1: 26.6666667,
    x2: 28.3333333,
    y2: 26.6666667,
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContractColor);
export default __webpack_public_path__ + "static/media/icon_contract_color.f4e823af51785e2ac055ddf5d7fc7029.svg";
export { ForwardRef as ReactComponent };